import type { RootState } from "@src/store/rootState";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

export const isOnsiteUpsellBuilder = (state: RootState): boolean =>
  experienceBuilderSlice.selectors.getOpenedAsOnsiteUpsell(state);
